var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_all"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1.25 15C1.25 7.40589 7.40589 1.25 15 1.25C22.5941 1.25 28.75 7.40589 28.75 15C28.75 22.5941 22.5941 28.75 15 28.75C7.40589 28.75 1.25 22.5941 1.25 15ZM15 3.75C8.78661 3.75 3.75 8.78661 3.75 15C3.75 21.2134 8.78661 26.25 15 26.25C21.2134 26.25 26.25 21.2134 26.25 15C26.25 8.78661 21.2134 3.75 15 3.75ZM13.7375 10C13.7375 9.30964 14.2971 8.75 14.9875 8.75H15C15.6904 8.75 16.25 9.30964 16.25 10C16.25 10.6904 15.6904 11.25 15 11.25H14.9875C14.2971 11.25 13.7375 10.6904 13.7375 10ZM15 13.75C15.6904 13.75 16.25 14.3096 16.25 15V20C16.25 20.6904 15.6904 21.25 15 21.25C14.3096 21.25 13.75 20.6904 13.75 20V15C13.75 14.3096 14.3096 13.75 15 13.75Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F08E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLg);
export default __webpack_public_path__ + "static/media/info-lg.677bcf08f05c90d3a5cc5e49b83b550e.svg";
export { ForwardRef as ReactComponent };